const timeManager = {
    listeners: [],
    date: null,
    tick() {
        this.date = new Date();
        this.listeners.forEach(fn => fn(this.date));
    },
    addListener (listener) {
        this.listeners.push(listener);
    },
    removeListener (listener) {
        const index = this.listeners.indexOf(listener);
        if (index > -1) {
            this.listeners.splice(index, 1);
        }
    }
}

setInterval(() => {
    timeManager.tick();
}, 1000);


export default timeManager;
